// extracted by mini-css-extract-plugin
export default {"form":"MealIteamForm_form__nNkfU"};